import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PWAInstallProvider } from "@/components/pwa/InstallPrompt";
import Landing from "@/pages/Landing";
import Enquire from "@/pages/Enquire";
import VerifyCertificate from "@/pages/VerifyCertificate";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import Cookies from "@/pages/legal/Cookies";
import { AuthProvider } from "@/app/AuthContext";
import ProtectedRoute from "@/app/ProtectedRoute";
import Login from "@/app/pages/Login";
import Signup from "@/app/pages/Signup";
import AcceptInvite from "@/app/pages/AcceptInvite";
import ForgotPassword from "@/app/pages/ForgotPassword";
import ResetPassword from "@/app/pages/ResetPassword";
import AppLaunch from "@/app/pages/AppLaunch";
import MyTraining from "@/app/pages/MyTraining";
import Dashboard from "@/app/pages/Dashboard";
import Competencies from "@/app/pages/Competencies";
import Team from "@/app/pages/Team";
import Documents from "@/app/pages/Documents";
import Learning from "@/app/pages/Learning";
import LearningReview from "@/app/pages/LearningReview";
import Training from "@/app/pages/Training";
import Reports from "@/app/pages/Reports";
import Admin from "@/app/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PWAInstallProvider>
          <AuthProvider>
            <Routes>
            {/* Marketing */}
            <Route path="/" element={<Landing />} />
            <Route path="/enquire" element={<Enquire />} />
            {/* Bare /verify is the address printed under "Scan to verify" on
                every certificate, and where the dossier QR codes point. Without
                this route it fell through to the catch-all below and rendered
                the marketing landing page. */}
            <Route path="/verify" element={<VerifyCertificate />} />
            <Route path="/verify/:certId" element={<VerifyCertificate />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/terms" element={<Terms />} />
            <Route path="/legal/cookies" element={<Cookies />} />

            {/* Customer app */}
            <Route path="/app" element={<AppLaunch />} />
            <Route path="/app/" element={<AppLaunch />} />
            <Route path="/app/login" element={<Login />} />
            <Route path="/app/signup" element={<Signup />} />
            <Route path="/app/accept-invite" element={<AcceptInvite />} />
            <Route path="/app/forgot-password" element={<ForgotPassword />} />
            <Route path="/app/reset-password" element={<ResetPassword />} />
            <Route
              path="/app/my-training"
              element={
                <ProtectedRoute>
                  <MyTraining />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/my-certificates"
              element={
                <ProtectedRoute>
                  <MyTraining />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/dashboard"
              element={
                <ProtectedRoute requireRole="owner">
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/competencies"
              element={
                <ProtectedRoute requireRole="owner">
                  <Competencies />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/team"
              element={
                <ProtectedRoute requireRole="owner">
                  <Team />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/documents"
              element={
                <ProtectedRoute requireRole="owner">
                  <Documents />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/learning"
              element={
                <ProtectedRoute requireRole="owner">
                  <Learning />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/learning/:moduleId"
              element={
                <ProtectedRoute requireRole="owner">
                  <Learning />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/training-modules"
              element={
                <ProtectedRoute requireRole="owner">
                  <Learning />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/training-modules/:moduleId"
              element={
                <ProtectedRoute requireRole="owner">
                  <Learning />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/learning-review"
              element={
                <ProtectedRoute requireRole="owner">
                  <LearningReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/learning-review/:moduleId"
              element={
                <ProtectedRoute requireRole="owner">
                  <LearningReview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/training"
              element={
                <ProtectedRoute requireRole="owner">
                  <Training />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/reports"
              element={
                <ProtectedRoute requireRole="owner">
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/admin"
              element={
                <ProtectedRoute requireRole="owner">
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/admin/:section"
              element={
                <ProtectedRoute requireRole="owner">
                  <Admin />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Landing />} />
          </Routes>
          </AuthProvider>
        </PWAInstallProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
